import { Component, computed, Output, signal, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { fadeInUp400ms } from '../../../@vex/animations/fade-in-up.animation';
import { stagger40ms } from '../../../@vex/animations/stagger.animation';
import { Subject } from 'rxjs';
import { PageLayoutComponent } from '../../../@vex/components/page-layout/page-layout.component';
import { PageLayoutHeaderDirective } from '../../../@vex/components/page-layout/page-layout-header.directive';
import { PageLayoutContentDirective } from '../../../@vex/components/page-layout/page-layout-content.directive';
import { UpdateProfileComponent } from './update-profile/update-profile.component';
import { UpdateMailComponent } from './update-mail/update-mail.component';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { UpdatePasswordComponent } from './update-password/update-password.component';
import { DeleteProfileComponent } from './delete-profile/delete-profile.component';

@Component({
	selector: 'vex-user-profile',
	templateUrl: './user-profile.component.html',
	styleUrl: './user-profile.component.scss',
	animations: [fadeInUp400ms, stagger40ms],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		TranslocoDirective,
		PageLayoutComponent,
		PageLayoutHeaderDirective,
		PageLayoutContentDirective,
		UpdateProfileComponent,
		UpdateMailComponent,
		MatButton,
		MatIcon,
		UpdatePasswordComponent,
		DeleteProfileComponent,
	],
})
export class UserProfileComponent {
	translocoService = inject(TranslocoService);

	isEdit = signal(false);

	allowUpdateEmail = signal(true);
	allowUpdateProfile = signal(true);

	hasChangedEmail = signal(false);
	hasChangedProfile = signal(false);

	@Output() updateEmail = new Subject<void>();
	@Output() updateProfile = new Subject<void>();

	allowUpdate = computed(() => {
		return this.allowUpdateEmail() && this.allowUpdateProfile();
	});

	formChanged = computed(() => {
		return this.hasChangedEmail() || this.hasChangedProfile();
	});

	setAllowUpdateEmail($event) {
		this.allowUpdateEmail.set($event);
	}

	setAllowUpdateProfile($event) {
		this.allowUpdateProfile.set($event);
	}

	setChangedEmail($event) {
		this.hasChangedEmail.set($event);
	}

	setChangedProfile($event) {
		this.hasChangedProfile.set($event);
	}

	edit() {
		this.isEdit.set(true);
	}

	cancel() {
		this.isEdit.set(false);
	}

	save() {
		this.isEdit.set(false);
		if (this.allowUpdateProfile() && this.hasChangedProfile()) {
			this.updateProfile.next();
		}
		if (this.allowUpdateEmail() && this.hasChangedEmail()) {
			this.updateEmail.next();
		}
	}
}
